import { render, staticRenderFns } from "./plans-inspirations-search-input.vue?vue&type=template&id=2aae64d7"
import script from "./plans-inspirations-search-input.js?vue&type=script&lang=js&external"
export * from "./plans-inspirations-search-input.js?vue&type=script&lang=js&external"
import style0 from "./plans-inspirations-search-input.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports